// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";

import { Controller, useForm } from "react-hook-form";

// ** Reactstrap Imports
import {
  Button,
  FormFeedback,
  Input,
  Spinner,
} from "reactstrap";

// ** Illustrations Imports
import { useForgetPassword } from "../api/forgetPassword";
import { toast } from "react-toastify";
import { ReactComponent as Logo } from "@src/assets/images/logo/logo.svg";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const formSchema = z.object({
  email: z.string().email("Invalid email address"),
});

const defaultValues = {
  email:""
}

export const ForgetPassword = () => {
  // ** Hooks
  const { skin } = useSkin();

  const {
    control,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues:defaultValues,
    resolver: zodResolver(formSchema),
  });

  const postForgetPasswordMutation = useForgetPassword({
    config: {
      onSuccess: () => {
        toast.success("Email send successfully");
        reset()
      },
    },
  });

  const onSubmitForm = (data) => {
    postForgetPasswordMutation.mutateAsync({
      data: { email: data.email },
    });
  };

  return (
      <div className={" auth-wrapper auth-basic"}>
        <div className="auth-inner my-2">
          <div className={'d-flex justify-content-center align-items-center gap-50 pb-2'}>
            <Logo />
            <h1 className={'text-center fw-bolder mb-0'}>
              PmChess
            </h1>
          </div>
          <h5 className={'mb-1 rounded-3 text-center w-100 border py-1'}>
            Reset Your Password
          </h5>
      <form
          onSubmit={handleSubmit(onSubmitForm)}
          className={"rounded-3 border p-2"}
      >
        <div className="form-floating mb-1">
          <Controller
              id="email"
              name="email"
              control={control}
              render={({field}) => (
                  <Input
                      type="email"
                      placeholder=""
                      defaultValue={defaultValues.email}
                      invalid={errors.email && true}
                      {...field}
                  />
              )}
          />
          <label htmlFor="email">Email</label>
        </div>
        {errors.email && (
            <FormFeedback className="d-block mb-1">
              {errors.email.message}
            </FormFeedback>
        )}

        {errors.exists && (
            <FormFeedback className="d-block mb-1">
              {errors.exists.message}
            </FormFeedback>
        )}

        <Button
            // onClick={() => }
            type="submit"
            color="primary"
            block
            size="lg"
            className={'mt-2'}
        >
          {postForgetPasswordMutation.isLoading ||
          postForgetPasswordMutation.isPending ? (
              <Spinner size={"sm"}/>
          ) : (
              "Send Reset Link"
          )}{" "}
        </Button>
      </form>
        </div>
      </div>
  );
};
